import React, { useRef, useState, useEffect } from "react";
import * as yup from "yup";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { Report, TonnageDisclaimer } from "../../../shared";
import { Fragment } from "react";

const schema = yup.object({
  epaId: yup.string().required("ID Number is required."),
  siteType: yup.string().required("Site Type is required."),
  shipYear: yup.string(),
});

function ManifestCountTonnageReport() {
  const location = useLocation();
  const params = queryString.parse(location.search);
  const searchOnInit = Object.keys(params).length > 0 ? true : false;
  const [initialFormValues, setInitialFormValues] = useState({
    epaId: params && params.epaId ? params.epaId : "",
    siteType: params && params.siteType ? params.siteType : "",
    shipYear: params && params.shipYear ? params.shipYear : "",
  });
  const [backToUrl, setBacktoUrl] = useState("/reports");
  const [pageTitle, setPageTitle] = useState("Manifest Count and Total Tons");
  const [apiEndpoint, setApiEndpoint] = useState(
    "/api/v1/hwts/search/facility/countandtonnage"
  );

  const formConfig = [
    {
      name: "epaId",
      config: {
        col: "md",
        colWidth: "3",
        label: "ID Number",
        placeholder: "",
        type: "text",
      },
    },
    {
      name: "siteType",
      config: {
        col: "md",
        colWidth: "3",
        label: "Site Type",
        placeholder: "",
        type: "select",
        data: [
          { label: "Generator", value: "generator" },
          { label: "Transporter", value: "transporter" },
          { label: "TSDF", value: "tsdf" },
        ],
      },
    },
    {
      name: "shipYear",
      config: {
        col: "md",
        validate: true,
        colWidth: "3",
        label: "Select a Ship Year",
        placeholder: "Select a Year",
        type: "select",
        apiEndpoint: "api/v1/hwts/search/ship-years",
        hasApi: true,
      },
    },
  ];

  return (
    <Fragment>
      <Report
        backToUrl={backToUrl}
        pageTitle={pageTitle}
        initialFormValues={initialFormValues}
        schema={schema}
        formConfig={formConfig}
        apiEndpoint={apiEndpoint}
        searchOnInit={searchOnInit}
      />
      <div className="container">
        <TonnageDisclaimer />
      </div>
    </Fragment>
  );
}

export default ManifestCountTonnageReport;
